// extracted by mini-css-extract-plugin
module.exports = {"root":"LicenceActions_root__1Acs5","action":"LicenceActions_action__1z_RA"};